import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TabControlComponent } from '../../shared/controls/tab-control/tab-control.component';
import { TabPageComponent } from '../../shared/controls/tab-control/tab-page.component';
import { ClientDetailComponent } from './client-detail/client-detail.component';
import { ClientAreaComponent } from './client-area/client-area.component';

@Component({
    templateUrl: './create-or-update-client.component.html',
    styleUrls: ['./create-or-update-client.component.scss'],

    imports: [
        CommonModule,
        FormsModule,
        TabControlComponent,
        TabPageComponent,
        ClientDetailComponent,
        ClientAreaComponent
    ],
})
export class CreateOrUpdateClientComponent implements OnInit {
    public clientId: number = 0;

    constructor(
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.clientId = Number(params.get('id'));
        });
    }
}